import { useHistory } from 'react-router-dom';

import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';

import { Navbar } from '@cobliteam/base-components';

import ClientAreaButton from './components/ClientAreaButton';
import CoblinatorModule from './components/CoblinatorModule';
import FeedbackButton from './components/FeedbackButton';
import HowToUseButton from './components/HowToUseButton';
import NotificationsButton from './components/NotificationsButton';

const NavbarDashboard = () => {
  const { coblinator } = useFeatureFlags();

  const history = useHistory();
  return (
    <Navbar onClickLogo={() => history.push('/')}>
      <div className='flex justify-end w-full mx-5 gap-2.5 items-center'>
        {coblinator ? <CoblinatorModule /> : null}
        <NotificationsButton />
        <FeedbackButton />
        <ClientAreaButton />
        <HowToUseButton />
      </div>
    </Navbar>
  );
};

export default NavbarDashboard;
